import React from 'react';
import UnderConstruction from '../../../components/common/underconstruction/UnderConstruction';

const Profile = () => {
    return (
        <UnderConstruction />
    );
};

export default Profile;